import { render, staticRenderFns } from "./TranslationEditor.vue?vue&type=template&id=f1beb7c8&scoped=true&lang=html&"
import script from "./TranslationEditor.vue?vue&type=script&lang=js&"
export * from "./TranslationEditor.vue?vue&type=script&lang=js&"
import style0 from "./TranslationEditor.vue?vue&type=style&index=0&id=f1beb7c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1beb7c8",
  null
  
)

export default component.exports